module.exports = __webpack_public_path__ + "media/images/phone-3372d6a4dfaba67b4d3e64c47ca9a21c.png";